import { Component, input, ViewChild } from '@angular/core';
import { SECDocumentViewerComponent } from '../sec-document-viewer/sec-document-viewer.component';

@Component({
  selector: 'sec-link',
  imports: [
    SECDocumentViewerComponent
  ],
  templateUrl: './sec-link.component.html',
  styleUrl: './sec-link.component.scss'
})
export class SecLinkComponent {

  readonly formid = input<number>(0)
  readonly docid = input<number>(0)
  readonly label = input<string>('')

  @ViewChild(SECDocumentViewerComponent) secViewerComponent: SECDocumentViewerComponent | undefined

  openDocument() {
    this.secViewerComponent?.displayDocumentViaFormIDAndDocID(this.formid(), this.docid())
  }
}
